<template>
    <div class="side-service"  >
      <div v-show="isVisible">
        <h3>欢迎咨询娄顾问</h3>
        <div
          class="service-item"
          @click="openQQ"
        >
        </div> 
        <div class="service-item">
          <span>电话号码：</span>
          <div style="font-weight: bold;color: #409eff;" >13426002550</div>
        </div>
        <!-- <div class="service-item wechat">
         
          <span>扫一扫添加</span>
          <div class="qrcode">
            <img src="./loujianweiwx.png" >
          </div>
          <img src="./loujianweiwx.png" style="width: 100px; height: 100px;" >
        </div> -->
        <button><div style="text-align: left;" @click="toggleVisibility" >关闭</div></button>
      </div>
      <div style="text-align: left;"  @click="toggleAfterVisibility">
      <div  v-show="afterIsVisible"  ><img src="../image/message.jpeg" style="width: 40px; height: 40px;" ><h3>客服</h3></div>
    </div>
    </div>
    
</template>
<script>
import { ref } from 'vue';
export default {
    setup() {
const isVisible = ref(true);
const afterIsVisible = ref(false);
const toggleVisibility = () => {
isVisible.value = !isVisible.value;
afterIsVisible.value = !afterIsVisible.value;
};
const toggleAfterVisibility = () => {
afterIsVisible.value = !afterIsVisible.value;
isVisible.value = !isVisible.value;
};
return { isVisible, toggleVisibility ,afterIsVisible,toggleAfterVisibility};

},
}
</script>
<style scop>
.side-service {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
    border-radius: 8px;
    padding: 20px;
  }
  
  .service-item {
    margin: 15px 0;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  
  .service-item img {
    width: 40px;
    height: 40px;
    display: block;
    margin: 0 auto;
  }
  
  .service-item span {
    display: block;
    font-size: 12px;
    color: #666;
    margin-top: 5px;
  }
  
  .wechat:hover .qrcode {
    display: block;
  }
  
  .qrcode {
    display: none;
    position: absolute;
    left: 60px;
    top: 0;
    padding: 10px;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }
  
  .qrcode img {
    width: 200px;
    height: 200px;
  }
</style>